import CumulAccess from "../enum/cumul/CumulAccess";
import { CumulRole } from "../enum/cumul/CumulRole";
import CumulShareType from "../enum/cumul/CumulShareType";
import CumulDashboard, { CumulAccessRight } from "../types/cumul/CumulDashboard";
import {
  CumulShareItem,
  CumulShareItemOrg,
  CumulShareItemTeam,
  CumulShareItemUser,
} from "../types/cumul/CumulShareItem";
import User from "../types/User";

// cumul role is entered manually in the db, correct casing is not always guaranteed, so we need
// to use .toLowerCase in order to ensure our comparison is correct
export const getUserCumulRole = (user?: User): CumulRole | undefined => {
  return Object.values(CumulRole).find((role) => role === user?.cumulRole?.toLowerCase());
};

export const parseCumulAccessRight = (access: CumulAccessRight): CumulAccess | undefined => {
  if (access.flagOwn) {
    return CumulAccess.CAN_OWN;
  } else if (access.flagModify) {
    return CumulAccess.CAN_EDIT;
  } else if (access.flagUse) {
    return CumulAccess.CAN_USE;
  } else if (access.flagRead) {
    return CumulAccess.CAN_VIEW;
  } else {
    return undefined;
  }
};

export const getShareItems = (dashboard: CumulDashboard): CumulShareItem[] => {
  const result: CumulShareItem[] = [];

  if (dashboard.groups?.some((item) => !item.teamId)) {
    result.push({ type: CumulShareType.ORG });
  }

  dashboard.groups?.forEach((item) => {
    if (item.teamId) {
      result.push({ id: item.teamId, type: CumulShareType.TEAM });
    }
  });

  const ownerId = dashboard.createdBy?.id;
  dashboard.users.forEach((item) => {
    if (item.userId && item.userId !== ownerId) {
      result.push({ id: item.userId, type: CumulShareType.USER });
    }
  });

  return result;
};

export const getUserShareItems = (dashboard: CumulDashboard): CumulShareItemUser[] => {
  const ownerId = dashboard.createdBy?.id;
  return dashboard.users.reduce((result, item) => {
    if (item.userId && item.userId !== ownerId) {
      result.push({ id: item.userId, type: CumulShareType.USER });
    }
    return result;
  }, [] as CumulShareItemUser[]);
};

export const getTeamShareItems = (dashboard: CumulDashboard): CumulShareItemTeam[] => {
  return (
    dashboard.groups?.reduce((result, item) => {
      if (item.teamId) {
        result.push({ id: item.teamId, type: CumulShareType.TEAM });
      }
      return result;
    }, [] as CumulShareItemTeam[]) ?? []
  );
};

export const getOrgShareItem = (dashboard: CumulDashboard): CumulShareItemOrg | undefined =>
  dashboard.groups?.some((item) => !item.teamId) ? { type: CumulShareType.ORG } : undefined;
